import { useStore } from 'effector-react'
import { Form } from '~/entities/Promotion'
import { createFx, formSubmitted, $defaultValues } from './model'

export const AddPromotion = () => {
  const isCreating = useStore(createFx.pending)

  const defaultValues = useStore($defaultValues)

  return (
    <Form
      isSubmitting={isCreating}
      onSuccess={formSubmitted}
      isCreating
      defaultValues={defaultValues}
    />
  )
}
